<template>
  <div style="background-color: #1F01D5;">
    <div>
      <img src="/static/icon/register.png" class="logo" />
    </div>
    <div style="padding: 12px 12px 40px 12px; height: 71vh;">
      <md-field>
        <input-validate
          type="text"
          title="Phone"
          name="phone"
          v-model="phone"
          placeholder="Enter phone number"
          v-validate="'required|phone'"
          data-vv-value-path="innerValue"
          data-vv-validate-on="blur"
          align="right"
          :error="errors.first('phone')"
        ></input-validate>
        <input-validate
          ref="password"
          title="Password"
          type="password"
          name="password"
          v-model="password"
          placeholder="Enter password"
          v-validate="'required|password'"
          data-vv-value-path="innerValue"
          data-vv-validate-on="blur"
          align="right"
          :error="errors.first('password')"
        ></input-validate>
        <input-validate
          title="Confirm"
          type="password"
          name="repassword"
          v-model="repassword"
          placeholder="Password, Again"
          v-validate="'required|confirmed:password'"
          data-vv-as="password"
          align="right"
          :error="errors.first('repassword')"
        ></input-validate>
        <md-input-item
          title="Invitercode"
          v-model="invitercode"
          disabled
          align="right"
        ></md-input-item>
        <span @click="go_login" class="go_login_btn"
          >Already have an account,Go login</span
        >

        <div v-if="cf_turnstile_sitekey">
          <vue-turnstile
            :site-key="cf_turnstile_sitekey"
            @verified="token = $event"
          />
        </div>
        <div class="registerbtn">
          <md-button class="primary" @click="registerClick" :loading="loading"
            >Register</md-button
          >
        </div>
      </md-field>
    </div>

    <md-captcha
      ref="captcha"
      v-model="show"
      :title="title"
      :maxlength="limit ? parseFloat(maxlength) : -1"
      :system="system"
      :mask="mask"
      :appendTo="appendTo"
      :autoCountdown="true"
      :count="120"
      count-normal-text="ReSend OTP"
      count-active-text="Resend in {$1} seconds"
      @submit="submit"
      @show="onShow"
      @hide="onHide"
      @send="onSend"
    >
      {{ content }}
    </md-captcha>
  </div>
</template>

<script>
import inputValidate from "@/components/input-validate";
import { Validator } from "vee-validate";
import { sendsms, register, cftoken, getsiteconfig } from "@/request/api";
import VueTurnstile from "@gaviti/vue-turnstile";

Validator.extend("phone", {
  getMessage: field => `${field} value do not meet right format`,
  validate: value => /^\d{10}$/.test(value)
});

Validator.extend("password", {
  getMessage: field => `${field} at least 6 digits`,
  validate: value => /^\S{6,}$/.test(value)
});

export default {
  name: "register",
  components: {
    inputValidate,
    VueTurnstile
  },

  data() {
    return {
      show: false,
      appendTo: document.body,
      title: "Please enter OTP",
      content: "",
      limit: true,
      maxlength: "4",
      mask: false,
      system: false,
      invitercode: "",
      loading: false,
      sendtoken: "",
      token: "",
      phone: "",
      password: "",
      repassword: "",
      cf_turnstile_sitekey: ""
    };
  },
  created() {
    this.invitercode = this.$route.params.invitercode;

    setTimeout(() => {
      if (this.token === "") {
        location.reload();
      }
    }, 8000);

    getsiteconfig().then(res => {
      if (res.code === 200) {
        this.cf_turnstile_sitekey = res.data.cf_turnstile_sitekey;
      }
    });
  },
  methods: {
    registerClick() {
      let that = this;
      this.$validator.validateAll().then(res => {
        if (res) {
          that.content =
            "OTP sent to " +
            that.phone.slice(0, 3) +
            "****" +
            that.phone.slice(that.phone.length - 4, that.phone.length);
          this.show = true;
        }
      });
    },
    onSend() {
      if (!this.token) {
        this.$refs.captcha.setError("Please try again");
        return;
      }
      this.$refs.captcha.setError();
      cftoken({ token: this.token }).then(res => {
        if (res.code == 200) {
          this.sendtoken = res.data.sendtoken;
          sendsms({
            phone: this.phone,
            sendtoken: this.sendtoken,
            purpose: "register"
          })
            .then(res => {
              if (res.code !== 200) {
                this.$refs.captcha.setError(res.errmsg);
                this.$refs.captcha.resetcount();
                this.sendtoken = "";
              }
            })
            .catch(error => {
              this.$refs.captcha.setError("Failed to send OTP, please resend");
              this.$refs.captcha.resetcount();
              this.sendtoken = "";
            });
        }
      });
    },
    onShow() {},
    onHide() {
      this.$refs.captcha.setError();
    },
    submit(val) {
      const max = parseFloat(this.maxlength);
      setTimeout(() => {
        if (!this.limit || max < 0 || val.length === max) {
          this.$toast.loading("Processing...");
          register({
            phone: this.phone,
            password: this.password,
            referral_code: this.invitercode,
            sendtoken: this.sendtoken,
            smscode: val
          }).then(res => {
            this.$toast.hide();
            if (res.code === 200) {
              this.$toast.succeed("Successfully registered");
              let that = this;
              setTimeout(() => {
                that.$router.push("/registersuccess");
              }, 1000);
            } else {
              this.$refs.captcha.setError(res.errmsg);
            }
          });
        }
      }, 300);
    },
    go_login() {
      this.$router.push("/login");
    },
    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    }
  }
};
</script>

<style>
#app {
  padding: 0 !important;
}

.logo {
  width: 100%;
}

.go_login_btn {
  font-size: 0.25rem;
  color: #007aff;
  float: right;
  padding-top: 20px;
}

.md-field {
  background-color: #ffffff;
  border-radius: 22px;
}

.registerbtn {
  margin-top: 1.5rem;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/register.vue